import { del, get, post } from '../../../helpers/api'
import { api } from '../api'
import {
  SET_CAMPAIGN_LIST_DATA,
  SET_CAMPAIGN_LOCATION_LIST_DATA,
  SET_ENROLLMENT_RANK_LIST_DATA,
  SET_ESAC_PROMOTION_LIST_DATA,
  SET_ESAC_REDEMPTION_LIST_DATA,
  SET_ESAC_VOUCHER_LIST_DATA,
  SET_ESAC_VOUCHER_SUB_TYPE_LIST_DATA,
  SET_ESAC_VOUCHER_TYPE_LIST_DATA,
  SET_FORM_DATA,
  SET_PAYMENT_WITH_MONETARY_VALUE_OPTIONS,
  SET_TEAM_BONUS_RANK_LIST_DATA,
  SHOW_NOTIFICATION,
} from '../../../store/types'
import * as T from '../../../store/types'
import error from '../../../pages/error'

export const getCampaignLocationListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.campaignLocationListing, query).then(response => {
      const json = response.data
      commit(SET_CAMPAIGN_LOCATION_LIST_DATA, {
        list: json,
      })
      resolve(response.data)
    })
  })
}
export const getTeamBonusRankListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.teamBonusRanksList, query).then(response => {
      const json = response.data
      commit(SET_TEAM_BONUS_RANK_LIST_DATA, {
        list: json,
      })
      resolve(response.data)
    })
  })
}
export const getEnrollmentRankListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.enrollmentRanksList, query).then(response => {
      const json = response.data
      commit(SET_ENROLLMENT_RANK_LIST_DATA, {
        list: json,
      })
      resolve(response.data)
    })
  })
}
// ------------------------------
//      CAMPAIGN
// ------------------------------
export const getCampaignListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.campaignListing, query).then(response => {
      const json = response.data
      commit(SET_CAMPAIGN_LIST_DATA, {
        list: json,
      })
      resolve(response.data)
    })
  })
}
export const getCampaignAction = ({ commit }, id) => {
  return new Promise(resolve => {
    get(api.campaign + '/' + id).then(response => {
      const json = response.data
      commit(SET_FORM_DATA, {
        formData: json,
      })

      resolve(response.data)
    })
  })
}
export const createCampaignAction = ({ commit }, data) => {
  return new Promise(resolve => {
    post(api.campaign, data).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Create Campaign', message: 'Operation success', type: 'positive' })
      resolve(response.data)
    })
  })
}
export const updateCampaignAction = ({ commit }, data) => {
  return new Promise(resolve => {
    post(api.campaign, data).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Update Campaign', message: 'Operation success', type: 'positive' })

      resolve(response.data)
    })
  })
}
export const deleteCampaignAction = ({ commit }, id) => {
  return new Promise(resolve => {
    del(api.campaign + '/' + id).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Delete Campaign', message: 'Operation success', type: 'info' })
      resolve(response.data)
    })
  })
}

// ------------------------------
//      ESAC VOUCHER TYPE
// ------------------------------
export const getEsacVoucherTypeListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.esacVoucherTypeListing, query).then(response => {
      const json = response.data
      commit(SET_ESAC_VOUCHER_TYPE_LIST_DATA, {
        list: json,
      })
      resolve(response.data)
    })
  })
}
export const getEsacVoucherTypeAction = ({ commit }, id) => {
  return new Promise(resolve => {
    get(api.esacVoucherType + '/' + id).then(response => {
      const json = response.data
      commit(SET_FORM_DATA, {
        formData: json,
      })

      resolve(response.data)
    })
  })
}
export const createEsacVoucherTypeAction = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    post(api.esacVoucherType, data)
      .then(response => {
        commit(SHOW_NOTIFICATION, { title: 'Create eSac Voucher Type', message: 'Operation success', type: 'positive' })
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}
export const updateEsacVoucherTypeAction = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    post(api.esacVoucherType, data)
      .then(response => {
        commit(SHOW_NOTIFICATION, { title: 'Update eSac Voucher Type', message: 'Operation success', type: 'positive' })
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}
export const deleteEsacVoucherTypeAction = ({ commit }, id) => {
  return new Promise(resolve => {
    del(api.esacVoucherType + '/' + id).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Delete eSac Voucher Type', message: 'Operation success', type: 'info' })
      resolve(response.data)
    })
  })
}

// ------------------------------
//      ESAC VOUCHER SUB TYPE
// ------------------------------
export const getEsacVoucherSubTypeListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.esacVoucherSubTypeListing, query).then(response => {
      const json = response.data
      commit(SET_ESAC_VOUCHER_SUB_TYPE_LIST_DATA, {
        list: json,
      })
      resolve(response.data)
    })
  })
}
export const getEsacVoucherSubTypeAction = ({ commit }, id) => {
  return new Promise(resolve => {
    get(api.esacVoucherSubType + '/' + id).then(response => {
      const json = response.data
      commit(SET_FORM_DATA, {
        formData: json,
      })

      resolve(response.data)
    })
  })
}
export const createEsacVoucherSubTypeAction = ({ commit }, data) => {
  return new Promise(resolve => {
    post(api.esacVoucherSubType, data).then(response => {
      commit(SHOW_NOTIFICATION, {
        title: 'Create eSac Voucher Sub Type',
        message: 'Operation success',
        type: 'positive',
      })
      resolve(response.data)
    })
  })
}
export const updateEsacVoucherSubTypeAction = ({ commit }, data) => {
  return new Promise(resolve => {
    post(api.esacVoucherSubType, data).then(response => {
      commit(SHOW_NOTIFICATION, {
        title: 'Update eSac Voucher Sub Type',
        message: 'Operation success',
        type: 'positive',
      })

      resolve(response.data)
    })
  })
}
export const deleteEsacVoucherSubTypeAction = ({ commit }, id) => {
  return new Promise(resolve => {
    del(api.esacVoucherSubType + '/' + id).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Delete eSac Voucher Sub Type', message: 'Operation success', type: 'info' })
      resolve(response.data)
    })
  })
}

// ------------------------------
//      ESAC PROMOTION
// ------------------------------
export const getEsacPromotionListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.esacPromotionListing, query).then(response => {
      const json = response.data
      commit(SET_ESAC_PROMOTION_LIST_DATA, {
        list: json,
      })
      resolve(response.data)
    })
  })
}
export const getEsacPromotionAction = ({ commit }, id) => {
  return new Promise(resolve => {
    get(api.esacPromotion + '/' + id).then(response => {
      const json = response.data
      commit(SET_FORM_DATA, {
        formData: json,
      })

      resolve(response.data)
    })
  })
}
export const createEsacPromotionAction = ({ commit }, data) => {
  return new Promise(resolve => {
    post(api.esacPromotion, data).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Create eSac Promotion', message: 'Operation success', type: 'positive' })
      resolve(response.data)
    })
  })
}
export const updateEsacPromotionAction = ({ commit }, data) => {
  return new Promise(resolve => {
    post(api.esacPromotion, data).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Update eSac Promotion', message: 'Operation success', type: 'positive' })

      resolve(response.data)
    })
  })
}
export const deleteEsacPromotionAction = ({ commit }, id) => {
  return new Promise(resolve => {
    del(api.esacPromotion + '/' + id).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Delete eSac Promotion', message: 'Operation success', type: 'info' })
      resolve(response.data)
    })
  })
}

// ------------------------------
//      ESAC VOUCHER
// ------------------------------
export const getEsacVoucherListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.esacVoucherListing, query).then(response => {
      const json = response.data
      commit(SET_ESAC_VOUCHER_LIST_DATA, {
        list: json,
      })
      resolve(response.data)
    })
  })
}
export const getEsacVoucherAction = ({ commit }, id) => {
  return new Promise(resolve => {
    get(api.esacVoucher + '/' + id).then(response => {
      const json = response.data
      commit(SET_FORM_DATA, {
        formData: json,
      })

      resolve(response.data)
    })
  })
}
export const createEsacVoucherAction = ({ commit }, data) => {
  return new Promise(resolve => {
    post(api.esacVoucher, data).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Create eSac Voucher', message: 'Operation success', type: 'positive' })
      resolve(response.data)
    })
  })
}
export const updateEsacVoucherAction = ({ commit }, data) => {
  return new Promise(resolve => {
    post(api.esacVoucher, data).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Update eSac Voucher', message: 'Operation success', type: 'positive' })

      resolve(response.data)
    })
  })
}
export const deleteEsacVoucherAction = ({ commit }, id) => {
  return new Promise(resolve => {
    del(api.esacVoucher + '/' + id).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Delete eSac Voucher', message: 'Operation success', type: 'info' })
      resolve(response.data)
    })
  })
}

// ------------------------------
//      ESAC REDEMPTION
// ------------------------------
export const getEsacRedemptionListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.esacRedemptionListing, query).then(response => {
      const json = response.data
      commit(SET_ESAC_REDEMPTION_LIST_DATA, {
        list: json,
      })
      resolve(response.data)
    })
  })
}

export const getPaymentModesWithMonetaryValueAction = ({ commit }, query) => {
  return new Promise(resolve => {
    get(api.paymentModesWithMonetaryValue, query).then(response => {
      const json = response.data
      commit(T.SET_PAYMENT_WITH_MONETARY_VALUE_OPTIONS, {
        list: json,
      })
      resolve(response)
    })
  })
}
